<mcg-loader [message]="translate('Cargando_datos')" [showLoader]="isLoading"></mcg-loader>
<jqxWindow #form jqxWindowAutoResize [theme]="environment.tema" [zIndex]="900" [autoOpen]="true"
  [showCloseButton]="true" [showCollapseButton]="true" [resizable]="true" (onClose)="onClose()"
  [title]="titleWindowListadoVolum + ' (' + countPartialResults() + ')'">
  <div class="formHeader" style="overflow-x: hidden;"></div>
  <div class="form" style="float:left; overflow-x: hidden;">
    <app-header #header [exportar]="true" [periodo]="true" [volumetricos]="true" [filtro]="true" [resetFiltro]="true"
      [buscador]="true" [noLibre]="true" (eventExportar)="onExportar()" (eventFilter)="onAceptar()"
      (eventResetFilter)="onResetFilter()" (eventBuscador)="onBuscar()">
    </app-header>

    <div style="float:left; margin-top: 6px; width: 100%; height: calc(100% - 90px);">
      <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapter" [appCellClick]
        [columnsresize]="true" [sortable]="true" [showrowlines]="false" [showcolumnlines]="true" [columns]="columns"
        [groupsheaderheight]="25" [pagesize]="50" [pagesizeoptions]='["50", "100", "200"]' [pagermode]="'simple'"
        [pagerheight]="25" [altrows]="true" [sortmode]="'many'" [filterable]="false" [enablebrowserselection]="true"
        [statusbarheight]="20" [rowsheight]="20" [columnsheight]="20" [localization]="langGrid" [groupable]="true"
        [showtoolbar]="true" [rendertoolbar]="createToolBar" (onBindingcomplete)="onBindingComplete()" [groups]='["elemento"]'
        (onFilter)="onGridDataUpdate()" (onRowclick)="onRowClick($event)">
      </jqxGrid>
    </div>
    <div style="float: left; margin-top: 8px; width: 100%;">
      <jqxButton style="float:left;" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
        [textPosition]='"left"' [imgSrc]='"/assets/images/center.png"' [value]="translate('Centrar')"
        (onClick)="onCentrar($event)">
      </jqxButton>
      <jqxButton style="float: left; margin-left: 4px;" [width]='90' [height]='26'
        [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/grafica.png"'
        [value]="translate('Grafico')" (onClick)="onGrafica($event)">
      </jqxButton>
      <jqxButton style="float: left; margin-left: 4px;" [width]='150' [height]='26'
        [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/resumen.png"'
        [value]="translate('Resumen') + ' ' + translate('Periodo').toLowerCase()" (onClick)="onResumen($event)">
      </jqxButton>
      <jqxButton style="float: left; margin-left: 4px;" [width]='80' [height]='26'
        [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/total.png"'
        [value]="translate('Total')" (onClick)="onTotal($event)">
      </jqxButton>
      <jqxButton style="float: left; margin-left: 4px;" [width]="100" [height]="26"
        [textImageRelation]="'imageBeforeText'" [textPosition]="'left'" (onClick)="closeWindow()"
        [value]="translate('Salir')">
      </jqxButton>
    </div>
  </div>
</jqxWindow>